import React from 'react';
import AnswerKeyQuestionsArray from './AnswerKeyQuestionsArray';

const AnswerKeyAux = ({ lesson, data, dir }) => {
  // only type 4 should be of importance, it's the image question item.
  const skippedType = [0, 1, 2, 3];

  if (skippedType.includes(data.content.core.type_id)) return null;

  console.log('Rendering AnswerKeyAux with data:', data);

  // only 1 core needs to be converted to an array
  const pageData = {
    ...data,
    content: {
      ...data.content,
      core: [data.content.core]
    }
  };

  return <AnswerKeyQuestionsArray lesson={lesson} data={pageData} dir={dir} />;
};

export default AnswerKeyAux;
